import {EntityState, EntityStore, QueryEntity, StoreConfig} from "@datorama/akita"
import {ModuleLayoutResult} from "app/Interface/Module/Layout/ModuleLayout"
import produce from "immer"

interface LayoutStoreProps extends EntityState<ModuleLayoutResult, string> {
  active: ModuleLayoutResult | null | string
  operation?: string
  create: boolean
}

@StoreConfig({name: 'settings.layouts', resettable: true, producerFn: produce})
class LayoutStore extends EntityStore<LayoutStoreProps> {
  constructor() {
    super({
      operation: undefined,
      create: false
    })
  }
}

export const layoutStore = new LayoutStore()

class LayoutQuery extends QueryEntity<LayoutStoreProps> {
  constructor(protected store: LayoutStore) {
    super(store)
  }
}

export const layoutQuery = new LayoutQuery(layoutStore)
